import { useMemo, useState } from 'react'
import { menuItemsAllowed } from '../../../../services/permission/menus'
import * as PickingHttp from '../../../../services/api/https/picking/picking.http'
import {
  getPeriodoMesAtual,
  parseToMysqlFormatWithTime,
} from '../../../../services/util/date.service'
import { errorHandler } from '../../../../services/util/error.service'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import {
  OCORRENCIA_FILTER_OPTIONS,
  OcorrenciaFilter,
  PickingStatus,
} from '../../../../constants/picking-status'
import { usePickingReconferenciaContext } from '../../../../contexts/PickingContext'

const MENU_ITEMS = [
  { id: 14, content: '1. Editar' },
  // { id: 15, content: '2. Apagar' },
  { id: 16, content: '3. Assoc Entregas' },
  { id: 17, content: '4. Assoc Areas de Separacao' },
  { id: 18, content: '5. Assoc Equipes' },
  { id: 19, content: '6. Preparar Para Download' },
  { id: 20, content: '7. Resumo de Separação' },
  { id: 24, content: '8. Histórico de Leitura' },
  //   { id: 25, content: 'Mais...' },
]

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  FILTERING: 'Filtrando dados',
  DELETE: 'Excluindo separação',
  PREPARE_DOWNLOAD: 'Preparando separação para download',
  SUCCESS_DOWNLOAD: 'Preparado para download',
  SUCCESS_DELETE: 'Separação deletada com sucesso',
}

const MODAL_INIT_INFO = {
  id: null,
  name: '',
  style: 'Reconferencia',
  status: 'Sem Entregas Associadas',
  company_id: '',
  type: '',
  referencia: '',
  observacao: '',
}
const INITIAL_STATE = {
  pickings: [],
  filterdPickings: [],
  modal: {
    show: false,
    data: null,
  },
  modalConfirmDelete: {
    show: false,
    data: null,
  },
  periodo: getPeriodoMesAtual(),
  selectedPick: {},
  pathToRedirect: null,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  empresas: [],
  selectedEmpresa: [],
  status: [],
  selectedStatus: [],
  selectedOcorrencia: [],
  histLeituraData: null,
}

export default function usePickingReconferencia() {
  const context = usePickingReconferenciaContext()
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      getMenuItems() {
        return menuItemsAllowed(MENU_ITEMS)
      },

      verifyMenuItemAllowed(menuItem) {
        return menuItemsAllowed([menuItem]).length > 0
      },

      toggleModal(show, data, tp_id) {
        if (tp_id !== 0)
          setState(prevState => ({
            ...prevState,
            modal: { show, data: { ...data, tp_id: tp_id } },
          }))
        else
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione o Operador Logístico desejado',
          }))
      },

      getPickings(dataInicial, dataFinal, selectedTp) {
        PickingHttp.getPickingsReconferencia(
          selectedTp,
          'all',
          parseToMysqlFormatWithTime(dataInicial),
          parseToMysqlFormatWithTime(dataFinal),
        )
          .then(pickings =>
            setState(prevState => ({
              ...prevState,
              pickings: pickings,
              filterdPickings: pickings,
              status: Array.from(new Set(pickings.map(p => p.status))).map(s => ({
                value: s,
                label: s,
              })),
              empresas: Array.from(new Set(pickings.map(p => p.company_name))).map(e => ({
                value: e,
                label: e,
              })),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      changeStatusToReadyToDownload(pick) {
        PickingHttp.alterarStatusParaProntoParaDownload(pick.id)
          .then(pick =>
            setState(prevState => {
              const index = prevState.pickings.findIndex(p => p.id === pick.id)
              if (index !== -1) prevState.pickings[index] = pick
              prevState.loadingMessage = LOAD_MESSAGE.SUCCESS_DOWNLOAD
              return { ...prevState }
            }),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      deletePick(pick) {
        PickingHttp.apagarPicking(pick.id)
          .then(() =>
            setState(prevState => {
              prevState.pickings = prevState.pickings.filter(p => p.id !== pick.id)
              prevState.loadingMessage = LOAD_MESSAGE.SUCCESS_DELETE
              return { ...prevState }
            }),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
          pathToRedirect: null,
          histLeituraData: null,
        }))
      },

      //Events
      onInit(selectedTp) {
        if (selectedTp === 0) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione o Operador Logístico desejado',
          }))
        } else {
          setState(prevState => ({
            ...prevState,
            periodo: context.pickingReconferenciaContext.selectedPeriodo,
            loadingMessage: LOAD_MESSAGE.FILTERING,
          }))
        }
      },

      onBtnNovo(selectedTp) {
        this.toggleModal(true, { ...MODAL_INIT_INFO }, selectedTp)
      },

      onModalClose() {
        setState(prevState => ({
          ...prevState,
          modal: { show: false, data: { ...MODAL_INIT_INFO } },
        }))
      },

      onModalDeleteClose() {
        setState(prevState => ({
          ...prevState,
          modalConfirmDelete: { show: false, data: null },
        }))
      },

      onModalSave(pick) {
        setState(prevState => {
          const index = prevState.pickings.findIndex(l => l.id === pick.id)
          if (index !== -1) prevState.pickings[index] = pick
          else prevState.pickings.unshift(pick)
          prevState.modal = { show: false, data: { ...MODAL_INIT_INFO } }
          return { ...prevState }
        })
      },

      onModalDeleteSave(pick) {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.DELETE,
          modalConfirmDelete: { show: false, data: null },
          selectedPick: pick,
        }))
      },

      onPrepararParaDownloadClicked(pick) {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.PREPARE_DOWNLOAD,
          selectedPick: pick,
        }))
      },

      onMenuItemEditarClicked(pick, selectedTp) {
        const { id, name, style, status, company_id, type, referencia, observacao } = pick
        const { SemEntregasAssociadas, ComEntregasAssociadas } = PickingStatus

        const isEditable = status === SemEntregasAssociadas.label || status === ComEntregasAssociadas.label
        this.toggleModal(
          true,
          { id, name, style, status, company_id, type, referencia, observacao, viewOnly: !isEditable },
          selectedTp,
        )
      },

      onMenuItemClicked(item, pick, selectedTp) {
        switch (item) {
          case '1. Editar':
            this.onMenuItemEditarClicked(pick, selectedTp)
            break
          case '2. Apagar':
            if (pick.type === 'Expedicao')
              setState(prevState => ({
                ...prevState,
                errorMessage: 'Esse tipo de picking não pode ser apagado.',
              }))
            else
              setState(prevState => ({
                ...prevState,
                modalConfirmDelete: { show: true, data: { pick } },
              }))
            break
          case '3. Assoc Entregas':
            setState(prevState => ({
              ...prevState,
              pathToRedirect: '/main/picking/assoc-entrega',
              selectedPick: pick,
            }))
            break
          case '4. Assoc Areas de Separacao':
            setState(prevState => ({
              ...prevState,
              pathToRedirect: '/main/picking/assoc-area',
              selectedPick: pick,
            }))
            break
          case '5. Assoc Equipes':
            setState(prevState => ({
              ...prevState,
              pathToRedirect: '/main/picking/assoc-equipe',
              selectedPick: pick,
            }))
            break
          case '6. Preparar Para Download':
            this.onPrepararParaDownloadClicked(pick)
            break
          case '7. Resumo de Separação':
            if (pick.status === 'Picking Concluido' || pick.status === 'Resumo Emitido') {
              setState(prevState => ({
                ...prevState,
                pathToRedirect: '/main/picking/resumo-separacao',
                selectedPick: pick,
              }))
            } else {
              setState(prevState => ({
                ...prevState,
                errorMessage:
                  'Somente o Picking com os status: PICKING_CONCLUIDO ou RESUMO_EMITIDO pode acessar o Resumo da Separação',
              }))
            }
            break
          case '8. Histórico de Leitura':
            setState(prevState => ({
              ...prevState,
              pathToRedirect: '/main/picking/historico-leitura',
              selectedPick: pick,
              histLeituraData: { pickingId: pick.id },
            }))
            break
          case 'Mais...':
            setState(prevState => ({
              ...prevState,
              pathToRedirect: '/main/picking/picking-mais-opcoes',
              selectedPick: pick,
            }))
            break
          default:
            break
        }
      },

      onBtnPesquisarClick(dataInicial, dataFinal) {
        context.setPickingReconferenciaContext(prevPickingReconferenciaContext => ({
          ...prevPickingReconferenciaContext,
          selectedPeriodo: { dataInicial, dataFinal },
        }))
        setState(prevState => ({
          ...prevState,
          periodo: { dataInicial, dataFinal },
          loadingMessage: LOAD_MESSAGE.FILTERING,
        }))
      },

      onExportarClick(pickings) {
        if (pickings.length !== 0) {
          const rows = [
            [
              'Código',
              'Picking-Descrição',
              'Tipo',
              'Empresa',
              'Status',
              'Qte Entrega',
              'Qte Equipes',
              'Qte Sku',
              'Peso',
            ],
          ]

          pickings.forEach(p => {
            const {
              id,
              name,
              type,
              company_name,
              status,
              qteDeliveries,
              qteTeams,
              qteSku,
              weight,
            } = p
            rows.push([
              id,
              name,
              type,
              company_name,
              status,
              qteDeliveries,
              qteTeams,
              qteSku,
              weight,
            ])
          })
          gerarArquivoExcel('pickings', rows, 'picking.xlsx')
        } else
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Não existe separação para ser exportada.',
          }))
      },

      onFilterChange(name, value) {
        setState(prevState => ({
          ...prevState,
          [name]: value,
        }))
      },

      filterPickings(pickings, selectedEmpresa, selectedStatus, selectedOcorrencia) {
        let filtered = pickings

        if (selectedEmpresa.length > 0) {
          filtered = filtered.filter(p => selectedEmpresa.includes(p.company_name))
        }

        if (selectedStatus.length > 0) {
          filtered = filtered.filter(p => selectedStatus.includes(p.status))
        }

        if (
          selectedOcorrencia.length > 0 &&
          selectedOcorrencia.length < OCORRENCIA_FILTER_OPTIONS.length
        ) {
          const showsOcorrencia = p =>
            [PickingStatus.PickingConcluido.label, PickingStatus.ResumoEmitido.label].includes(
              p.status,
            )
          const atendeOcorrencia = p =>
            selectedOcorrencia.some(o => {
              if (o === OcorrenciaFilter.ComFalta) return p.has_falta
              if (o === OcorrenciaFilter.ComSobra) return p.has_sobra
              if (o === OcorrenciaFilter.ComFaltaSobra) return p.has_falta && p.has_sobra
              return false
            })
          filtered = filtered.filter(p => showsOcorrencia(p) && atendeOcorrencia(p))
        }

        setState(prevState => ({
          ...prevState,
          filterdPickings: filtered,
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
